import ModalNavigation from './ModalNavigation';

export default ModalNavigation;
